export type TMenuSurvey = "2300" | "2400" | "2500" | "2900" | "3100";
export const dataMenuCode = ["2300", "2400", "2500", "2900", "3100"];

export interface ISurvey {
  code: TMenuSurvey;
  score: number;
  slug: string;
  countResponsibility: number;
}
